export default __webpack_public_path__ + "static/media/developer-program.d7ea9f82.gif";